module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.obj) ? _c('div', {
    staticClass: "article-wrapper"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v(_vm._s(_vm.obj.title))]), _vm._v(" "), _c('p', {
    staticClass: "article-desc"
  }, [_vm._v("来源:" + _vm._s(_vm.obj.source) + " " + _vm._s(_vm.timeDisplay(_vm.obj.publish_time * 1000)))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "external_content",
    domProps: {
      "innerHTML": _vm._s(_vm.obj.content)
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f59f181!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/article-detail.vue
// module id = 241
// module chunks = 1